<template>
  <div class="complaint-auth">
    <div class="c-user">
      <div class="c-avatar">
        <cloud-img :border-radius="6" :img-height="40" :img-width="40" :url="user?.avatar"></cloud-img>
      </div>
      <div>
        <div class="c-username-g">
          <div class="c-username">{{ user?.nickname }}</div>
          <div v-if="tag === '投诉人'" class="c-tag c-tag-by">{{ tag }}</div>
          <div v-if="tag === '被投诉人'" class="c-tag c-tag-to">{{ tag }}</div>
        </div>
        <div class="c-phone">{{ user?.phone }}</div>
      </div>
    </div>
    <div class="teacher-info">
      <div v-if="user?.complaintTeacher">
        <div>教师注册姓名：{{ user.complaintTeacher.name }}</div>
        <div>教师籍贯：{{ user.complaintTeacher.address || '无填写信息' }}</div>
        <div>毕业学校：{{ user.complaintTeacher.school || '无填写信息' }}</div>
      </div>
      <div v-else class="info-text">
        无教师信息
      </div>
    </div>
  </div>
</template>
<script>
import CloudImg from "@/components/base/layout/img/CloudImg.vue"

export default {
  name: 'complaint-user',
  components: {CloudImg},
  props: {
    user: {},
    tag: {
      type: String,
      default: '投诉人'
    }
  }
}
</script>
<style scoped>
.c-user {
  display: flex;
  align-items: center;
  gap: 6px;
}

.c-username {
  font-weight: bold;
}

.complaint-auth {
  width: 100%;
  background: #f1f1f1;
  border-radius: 10px;
  padding: 10px 15px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 8px;
  height: 140px;
}

.c-tag {
  font-weight: bold;
  color: white;
  width: fit-content;
  padding: 2px 6px;
  border-radius: 6px;
  font-size: 10px;
  height: fit-content;
}

.c-tag-by {
  background: #2e4a67;
}

.c-tag-to {
  background: #672e2e;
}

.c-username-g {
  display: flex;
  gap: 12px;
}

.c-phone {
  font-size: 16px;
  color: #8a8a8a;
}

.teacher-info {
  border-top: #d8d8d8 1px solid;
  padding-top: 12px;
  font-size: 13px;
  color: #8a8a8a;
}

</style>
